export default {
  labels: {
    custom: 'Custom - Available on request',
    was: 'Was {{amount}} – annual discount applied',
  },
  tags: {
    preferred: 'Especially popular',
    net_one_time: 'net one-time',
    annual_discount: '-{{percentage}}% annual',
  },
  buttons: {
    select_plan: 'Choose this plan',
  },
};
